module.exports = __webpack_public_path__ + "img/success.14b03f92.png";